<template>
  <div class="config-card">
    <div class="config-card__top">
      <div>
        <TabSlide
          v-model:value="activeName"
          :options="tabs"
          :padding-size="2"
          @change="changeTab"
        />
      </div>

      <el-button
        color="#7a52f4"
        :disabled="tableDataList.length === 20"
        style="border-radius: 8px"
        @click="handleAddRule"
      >
        <i class="icon-add-line t-iconfont" style="margin-right: 5px" />新增提炼规则（{{
          tableDataList.length
        }}/{{ allCounts }}）</el-button
      >
    </div>
    <div class="config-card__rules">
      <VueDraggable
        v-model="tableDataList"
        :animation="150"
        handle=".drag-handle"
        target="tbody"
        @end="handleDragEnd"
      >
        <el-table
          v-loading="tableLoading"
          :cell-style="{ color: '#323233' }"
          class="no-header-border usage-details-card__table--content"
          :data="tableDataList"
          :header-cell-style="{
            color: '#646566' // 表头字体颜色
          }"
          max-height="400"
        >
          <el-table-column align="center" label="排序" width="48">
            <template #default>
              <i class="drag-handle icon-draggable t-iconfont" style="cursor: move" />
            </template>
          </el-table-column>
          <el-table-column label="规则名称" label-class-name="show-cell-left" width="164">
            <template #default="{ row }">
              <el-tooltip :content="row?.name || '-'" placement="top">
                <div class="table-text-ellipsis">{{ row?.name || '-' }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="是否启用" label-class-name="show-cell-left" width="74">
            <template #default="{ row }">
              <el-switch
                v-model="row.enable"
                :active-value="1"
                :inactive-value="0"
                style="--el-switch-on-color: #7a52f4; --el-switch-off-color: #969799"
                @change="handleEnable(row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="适用范围" label-class-name="show-cell-left">
            <template #default="{ row }">
              <el-tooltip
                :content="
                  row?.userRangePojo?.length > 0
                    ? row.userRangePojo.map((i) => i.name).join('、')
                    : '全公司'
                "
                placement="top"
              >
                <div class="table-text-ellipsis">
                  {{
                    row?.userRangePojo?.length > 0
                      ? row.userRangePojo.map((i) => i.name).join('、')
                      : '全公司'
                  }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作" label-class-name="show-cell-left" width="160">
            <template #default="scope">
              <div class="table-actions">
                <el-button
                  class="table-action-btn"
                  size="small"
                  type="text"
                  @click="handleCopy(scope.row)"
                  >复制</el-button
                >
                <el-button
                  class="table-action-btn"
                  size="small"
                  type="text"
                  @click="handleEdit(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  class="table-action-btn"
                  size="small"
                  type="text"
                  @click="handleDelete(scope.row)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </VueDraggable>
    </div>

    <!-- 新增/编辑弹窗 -->
    <Dialog
      v-model="editVisible"
      :max-height="800"
      :max-width="1008"
      :min-height="600"
      :min-width="800"
      :title="titleText"
    >
      <div class="dialog-body">
        <ai-meeting-followup
          v-if="editVisible"
          ref="aiMeetingFollowupRef"
          v-model:is-liberal-rules="isLiberalRules"
          v-model:liberal-rule="liberalRule"
          :enable-liberal-rules="enableLiberalRules"
          :if-rules-choose="ifRulesChoose"
          :operate-data="operateData"
        ></ai-meeting-followup>
      </div>
      <template #footer>
        <el-button class="dialog-btn" @click="editVisible = false">取 消</el-button>
        <el-button class="dialog-btn" color="#7a52f4" :loading="saveLoading" @click="handleSave"
          >确 定</el-button
        >
      </template>
    </Dialog>
    <!-- 删除确认弹窗 -->
    <Dialog v-model="deleteVisible" title="删除" width="400px">
      <i class="icon-error-warning-line t-iconfont" style="color: #ffb521; margin-right: 10px" />
      <span>删除后将不可恢复，确定删除吗</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="deleteVisible = false">取 消</el-button>
          <el-button color="#F54E4E" :loading="deleteLoading" @click="handleDeleteItem"
            >确 定</el-button
          >
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from 'vue'
import TabSlide from '@/pages/ai-board/components/components/ai-detail-dialog/components/tab-slide.vue'
// import Dialog from '@/components/ai-dialog/index.vue'
import Dialog from '@/components/layout/dialog-layout/index.vue'
import { VueDraggable } from 'vue-draggable-plus'
import AiMeetingFollowup from '@/pages/ai-board/components/ai-meeting-followup.vue'
import xbb from '@xbb/xbb-utils'

import {
  getRuleList,
  ruleDelete,
  enableRule,
  getRuleDetail,
  ruleSave,
  copySummaryRule,
  sortSummaryRule
} from '@/api/ai-board'

import { ElMessage } from 'element-plus'

const props = defineProps({
  configInfo: {
    type: Object,
    required: true
  }
})

const allCounts = ref(20)
const tableDataList = ref([])
const editVisible = ref(false)
const activeName = ref('chat')
const tableLoading = ref(false)
const enableLiberalRules = ref(0) // 是否有自由规则配置权限
const isLiberalRules = ref(0) // 0: 格式化规则 1: 自由规则
const liberalRule = ref('')
const dataId = ref(null)
const operateData = ref({})
const deleteVisible = ref(false)
const deleteLoading = ref(false)
const titleText = ref('编辑')
const saveLoading = ref(false)
const aiMeetingFollowupRef = ref(null)

const ifRulesChoose = ref(true)

const typeEnum = ref({
  chat: 0,
  call: 1,
  phone: 2
})

const tabs = computed(() => {
  const tabs = [{ name: '音视频', key: 'chat' }]
  if (callCenterEnable.value || ykMobileEnable.value) {
    tabs.push({ name: '通话内容', key: 'call' })
  }
  if (ykMobileEnable.value || larkGroupEnable.value) {
    tabs.push({ name: '聊天记录', key: 'phone' })
  }
  return tabs
})

// 是否开启呼叫中心
const callCenterEnable = computed(() => props.configInfo.config?.callCenterEnable === 1)
// 是否开启云客手机
const ykMobileEnable = computed(() => props.configInfo.config?.ykMobileEnable === 1)
// 是否开启飞书群聊
const larkGroupEnable = computed(() => props.configInfo.config?.larkGroupEnable === 1)

const getType = () => {
  return typeEnum.value[activeName.value]
}

const handleDragEnd = () => {
  sortSummaryRule({ idIn: tableDataList.value.map((i) => i.id), type: getType() })
    .then((res) => {})
    .catch(() => {
      getList()
    })
}

// 新增提炼规则模板的数量限制检查
const checkModelCount = () => {
  if (tableDataList.value.length >= allCounts.value) {
    ElMessage.error('可新增规则已达数量上限')
    return false
  }
  return true
}

/**
 * 复制规则模板
 * @param data 规则模板数据
 */
const handleCopy = (data) => {
  if (!checkModelCount()) {
    return
  }
  ifRulesChoose.value = activeName.value === 'chat'
  titleText.value = '新增提炼规则'
  copySummaryRule({ dataId: data.id, type: getType() }).then((res) => {
    editVisible.value = true
    operateData.value = {
      ...res.result,
      isDefault: data.isDefault,
      isAdd: true,
      id: null,
      userRangePojo: []
    }
    liberalRule.value = res.result.liberalRule
    isLiberalRules.value = res.result.isLiberalRules
  })
}

const handleEnable = (data) => {
  enableRule({
    dataId: data.id,
    enable: data.enable,
    type: getType()
  }).catch(() => {
    getList()
  })
}

const handleDelete = (data) => {
  dataId.value = data.id
  deleteVisible.value = true
}

const handleDeleteItem = () => {
  deleteLoading.value = true
  ruleDelete({ dataId: dataId.value, type: getType() })
    .then((res) => {
      getList()
      dataId.value = null
    })
    .finally(() => {
      deleteLoading.value = false
      deleteVisible.value = false
    })
}

const handleEdit = async (data) => {
  dataId.value = data.id
  titleText.value = '编辑'
  ifRulesChoose.value = activeName.value === 'chat'
  try {
    const res = await getRuleDetail({ dataId: data.id, type: getType() })
    operateData.value = {
      ...res.result,
      isDefault: data.isDefault,
      userRangePojo: res.result.userRangePojo || []
    }
    isLiberalRules.value = res.result.isLiberalRules
    liberalRule.value = res.result.liberalRule
    editVisible.value = true
  } catch (error) {
    ElMessage.error('获取规则详情失败')
    console.error('获取规则详情失败:', error)
  }
}

const handleAddRule = () => {
  if (activeName.value === 'chat') {
    handleAdd()
  } else {
    addCallRules() // 新增呼叫中心规则、后续云客手机新增规则也调用这个方法
  }
}

const addCallRules = () => {
  if (!checkModelCount()) {
    return
  }
  ifRulesChoose.value = false
  dataId.value = null
  operateData.value = {
    name: '',
    userRangePojo: []
  }
  liberalRule.value = ''
  titleText.value = '新增提炼规则'
  isLiberalRules.value = 1
  editVisible.value = true
}

const handleAdd = () => {
  if (!checkModelCount()) {
    return
  }
  ifRulesChoose.value = true
  dataId.value = null
  operateData.value = {
    name: '规则名称',
    isDefault: 0,
    metricRulePojo: {
      isOpenBehaviorMetricRule: 1,
      contentMetricRule: {
        summary: [
          {
            itemName: '',
            itemDesc: '',
            itemValues: [
              {
                ruleName: '',
                ruleValue: ''
              }
            ]
          }
        ]
      },
      todoMetricRule: []
    },
    userRangePojo: []
  }
  liberalRule.value = ''
  isLiberalRules.value = enableLiberalRules.value ? 1 : 0 // 如果可以配置自由规则，则默认值是自由规则
  titleText.value = '新增'
  editVisible.value = true
}

const handleSave = () => {
  const ruleData = aiMeetingFollowupRef.value?.ruleData

  if (!ruleData.name) {
    ElMessage.error('请填写规则名称')
    return
  }

  const summarys = xbb._get(ruleData, 'metricRulePojo.contentMetricRule.summary', [])
  const isEmpty = summarys.some(
    (summary) => !summary.itemName || summary.itemValues.some((itemValue) => !itemValue.ruleName)
  )
  if (isEmpty && isLiberalRules.value === 0) {
    ElMessage.error('请填写指标名称')
    return
  } else if (
    enableLiberalRules.value &&
    isLiberalRules.value === 1 &&
    (!liberalRule.value || liberalRule.value.length < 10 || liberalRule.value.length > 2000)
  ) {
    ElMessage.error('自由规则字数应在10-2000之间')
    return
  }

  const params = {
    ...ruleData,
    liberalRule: liberalRule.value,
    type: getType(),
    isLiberalRules: isLiberalRules.value
  }
  if (operateData.value.id) {
    params.id = operateData.value.id
  }
  saveLoading.value = true
  ruleSave(params)
    .then(() => {
      editVisible.value = false
      titleText.value = '编辑'
      getList()
    })
    .finally(() => {
      saveLoading.value = false
    })
}
const changeTab = () => {
  getList()
}

const getList = async () => {
  tableLoading.value = true
  const type = getType()
  try {
    const res = await getRuleList({ type })
    if (activeName.value === 'chat') {
      enableLiberalRules.value = res.result.enableLiberalRules
    } else {
      enableLiberalRules.value = 1 // 呼叫中心和云客手机默认都走自由规则组件
    }
    tableDataList.value = []
    nextTick(() => {
      tableDataList.value = xbb._get(res, 'result.list', [])
    })
  } catch (error) {
    console.error('获取规则列表失败:', error)
  } finally {
    tableLoading.value = false
  }
}

onMounted(() => {
  getList()
})
</script>

<style lang="scss" scoped>
// 导入公共SCSS变量
@use '@/style/common.scss' as *;
.config-card {
  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  .table-text-ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
  }

  $table-action-color: #248df5; // 链接/Link-6 常规
  $table-action-font-size: 12px; // 六级文字/常规
  $table-action-line-height: 16px; // 六级文字/常规

  .table-actions {
    display: flex;
    align-items: center;

    :deep(.el-button + .el-button) {
      margin-left: 8px;
    }
  }

  .table-action-btn {
    padding: 0;
    margin: 0;
    height: auto;
    border: none;
    font-size: $table-action-font-size;
    line-height: $table-action-line-height;
    color: $table-action-color;
  }
}

.dialog-body {
  min-height: 340px;
  max-height: 656px;
  // overflow-y: scroll;
  :deep(.is-free) {
    // textarea
    .el-textarea {
      .el-textarea__inner {
        padding: 16px 4px 0 20px;
        font-size: 16px;
        line-height: 28px;
      }
    }
  }
}
.dialog-btn {
  border-radius: 8px;
}
</style>
